(() => {
  const colorAliases = [
    ['black', ['black', 'שחור']],
    ['beige', ['beige', 'בז', 'בז׳', "בז'"]],
    ['red', ['red', 'אדום']],
    ['blue', ['blue', 'כחול', 'תכלת']],
    ['pink', ['pink', 'ורוד']],
    ['orange', ['orange', 'כתום']],
    ['aqua', ['aqua', 'אקווה', 'טורקיז']],
    ['grey', ['grey', 'gray', 'אפור']]
  ];
  const normalizeColor = (value = '') => {
    const source = String(value).trim().toLowerCase();
    for (const [key, aliases] of colorAliases) {
      if (aliases.some((alias) => source.includes(alias.toLowerCase()))) return key;
    }
    return source;
  };
  const normalizeSize = (value = '') => {
    const source = String(value).trim().toUpperCase();
    return ['XXL', 'XS', 'XL', 'S', 'M', 'L'].find((size) => {
      return new RegExp(`(^|[^A-Z])${size}([^A-Z]|$)`).test(source);
    }) || source;
  };
  const aliasList = (value, fallback) => String(value || fallback)
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);
  const optionIndex = (optionNames, aliases, fallback) => {
    const names = Array.isArray(optionNames) ? optionNames : [];
    const index = names.findIndex((name) => aliases.includes(String(name || '').trim().toLowerCase()));
    return index >= 0 ? index : fallback;
  };
  const findVariant = ({
    variants,
    optionNames,
    color,
    size = '',
    colorOptionLabels,
    sizeOptionLabels
  }) => {
    const candidates = Array.isArray(variants) ? variants : [];
    const wantedColor = normalizeColor(color);
    const wantedSize = normalizeSize(size);
    if (!wantedColor || (size && !wantedSize)) return null;
    const colorIndex = optionIndex(optionNames, aliasList(colorOptionLabels, 'Color,Colour,צבע'), 0);
    const sizeFallback = colorIndex === 0 ? 1 : 0;
    const sizeIndex = optionIndex(optionNames, aliasList(sizeOptionLabels, 'Size,מידה'), sizeFallback);
    return candidates.find((variant) => {
      const options = Array.isArray(variant?.options) ? variant.options : [];
      if (normalizeColor(options[colorIndex]) !== wantedColor) return false;
      return !size || normalizeSize(options[sizeIndex]) === wantedSize;
    }) || null;
  };

  window.SafeWalkV51AccessoryVariants = Object.freeze({
    findVariant,
    normalizeColor,
    normalizeSize
  });
})();
